import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';
import {
    updateSharingLinkFromSharingDialog,
    updateSharePointLinkUrl,
} from '../actions/internalActions';

// For both actions where the url changes, we need to discard the unwrappedUrl from previous url.
mutator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (sharingLink) {
        sharingLink.unwrappedUrl = null;
    }
});

mutator(updateSharePointLinkUrl, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    if (sharingLink) {
        sharingLink.unwrappedUrl = null;
    }
});
